var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "collapse_text",
      class: {
        "collapse_text-less": _vm.isLessMode,
        "collapse_text-more": _vm.isMoreMode,
      },
    },
    [
      _c("div", {
        ref: "text",
        staticClass: "collapse_text__text pseudo_input pseudo_input-dark",
        style: _vm.style,
        domProps: { textContent: _vm._s(_vm.value) },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse_text__control",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.toggle.apply(null, arguments)
            },
          },
        },
        [
          _vm.isLessMode
            ? _c("i", { staticClass: "fas fa-chevron-down ml-2 mr-1" })
            : _vm._e(),
          _vm._v(" "),
          _vm.isMoreMode
            ? _c("i", { staticClass: "fas fa-chevron-up" })
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }